import AppShell from "./AppShell.js";
import Website from "./Website.js";

/**
 * Route split:
 *  - "/"            → the marketing website (storefront)
 *  - "/app"         → the Alinq app
 *  - "/@handle..."  → address resolution; deep-link into the app, prefilled
 *  - Capacitor native always shows the app.
 */
function isCapacitorNative(): boolean {
  const w = window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } };
  return Boolean(w.Capacitor?.isNativePlatform?.()) || window.location.protocol === "capacitor:";
}

export default function App() {
  const path = window.location.pathname;
  const isAddressLink = /^\/@/.test(path);
  const isApp = isCapacitorNative() || path === "/app" || path.startsWith("/app/") || isAddressLink;
  return isApp ? <AppShell /> : <Website />;
}
